import { createAction, props } from '@ngrx/store';
import { RequestManagerCreate, ResponseReqManagerCreate } from '../../shared/interfaces';
import { ReqManagerCreateTypes } from '../../shared/enums';

export const getReqManagerCreate = createAction(
    ReqManagerCreateTypes.REQUEST_MANAGER_CREATE,
    props<{ request: RequestManagerCreate}>()
);

export const getReqManagerCreateSucess = createAction(
    ReqManagerCreateTypes.REQUEST_MANAGER_CREATE_SUCCESS,
    props<{ response: ResponseReqManagerCreate }>()
);

export const getReqManagerCreateError = createAction(
    ReqManagerCreateTypes.REQUEST_MANAGER_CREATE_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    ReqManagerCreateTypes.CLEAN_STATE
);

